<!-- Do not change this file. -->

<template>
  <div class="alert alert-warning text-dark text-start p-0">
    <div class="fw-bold h5 text-uppercase pt-2 ps-2">(Vuex) Datastore</div>
    <table class="table table-striped m-0 p-0" aria-label="(Vuex) Datastore">
      <tbody>
        <tr>
          <th>
            Entry<br /><span
              class="badge"
              :class="{
                'bg-success': entryLoaded,
                'bg-danger': !entryLoaded
              }"
              >Loaded</span
            >
          </th>
          <td class="text-end">
            <pre class="alert alert-secondary text-start">{{ getEntry }}</pre>
            <button class="btn btn-sm btn-danger me-3" @click="deleteData()">
              <i class="bi bi-trash me-2"></i>Delete My Data
            </button>
            <button class="btn btn-sm btn-secondary" @click="readEntry()">
              <i class="bi bi-arrow-clockwise me-2"></i>Refresh
            </button>
          </td>
        </tr>
        <tr>
          <th>
            Entries<br /><span
              class="badge"
              :class="{
                'bg-success': entriesLoaded,
                'bg-danger': !entriesLoaded
              }"
              >Loaded</span
            >
          </th>
          <td class="text-end">
            <pre class="alert alert-secondary text-start">{{ getEntries }}</pre>
            <button class="btn btn-sm btn-secondary" @click="readEntries()">
              <i class="bi bi-arrow-clockwise me-2"></i>Refresh
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
/* Do not change this file. */

import DatastoreAPI from "@/helpers/DatastoreAPI";
import { mapState, mapGetters } from "vuex";

export default {
  name: "DebugDatastore",
  mixins: [DatastoreAPI],
  computed: {
    ...mapState("datastore", ["entryLoaded", "entriesLoaded"]),
    ...mapGetters("datastore", ["getEntry", "getEntries"])
  },
  methods: {
    deleteData() {
      if (confirm("Clear user data?")) {
        this.deleteEntry();
        setTimeout(() => {
          location.reload();
        }, 1000);
      }
    }
  }
};
</script>
